import { type FC } from "react";
import classNames from "classnames";
import { parseDateToRender, parseHashToRender } from "../../../utils";
import { IconEthereum } from "../../icons";
import { RiCheckboxCircleFill } from "react-icons/ri";
import { RiCloseCircleFill } from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { Anchor } from "../../Anchor";
import { ITransaction } from "../../../logic/helpers";
import { app } from "app.config";

interface Props {
  className?: string;
  transaction?: ITransaction;
}

export const Transaction: FC<Props> = ({ className, transaction }) => {
  return (
    <>
      <div className={classNames("w-full pt-4 ", [className])}>
        {transaction ? (
          <>
            <div className="w-7 h-7 bg-white rounded-full p-0.5 mr-2">
              <IconEthereum />
            </div>
            <Anchor
              href={`https://${
                app.CHAIN.name === "goerli" || app.CHAIN.name === "sepolia"
                  ? app.CHAIN.name + "."
                  : ""
              }etherscan.io/tx/${transaction.hash}`}
              target="_blank"
              title="Etherscan"
              rel="noopener noreferrer"
              className="underline-offset-4 hover:underline cursor-pointer text-sm"
            >
              {parseHashToRender(transaction.hash, {
                initLength: 4,
                endLength: 24,
              })}
            </Anchor>
          </>
        ) : (
          <span className="text-sm">-</span>
        )}
      </div>
      <div className="pt-4">
        {transaction ? (
          <div className="w-7 h-7 ml-2.5">
            {transaction.status === 0 && (
              <RiCloseCircleFill className="text-red-600 w-full h-full" />
            )}
            {transaction.status === 1 && (
              <RiCheckboxCircleFill className="text-green-400 w-full h-full" />
            )}
            {transaction.status === undefined && (
              <AiOutlineLoading3Quarters className="animate-spin w-full h-full" />
            )}
          </div>
        ) : (
          <span className="text-sm">-</span>
        )}
      </div>
      <div className="pt-4">
        {transaction ? (
          <span className="text-sm">
            {!transaction.date ? "" : parseDateToRender(transaction.date)}
          </span>
        ) : (
          <span className="text-sm">-</span>
        )}
      </div>
    </>
  );
};

const richTextMintSuccess =
  "Your petition is being processed. You can check the transaction status in the panel below.";
